import { Navigate, useLocation } from "react-router-dom";
import { server } from "../../globalSettings";

export const requestOption = (method, data) => {
    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json' },
        };
        return requestOptions
    }

}

export const requestAuthOption = (method, data) => {
    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`, },
        };
        return requestOptions
    }

}

// api
export const loginApi = async (user) => {
    const request = requestOption("POST", user)
    try {
        const response = await fetch(`${server}login`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        if (data.code === "account_inactive") {
                            reject(["The account is inactive"]);
                        }
                        else {
                            reject(["Username and password are invalid. Please enter correct email and password"]);
                        }
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const logoutApi = async () => {
    const request = requestAuthOption("POST")
    try {
        const response = await fetch(`${server}logout`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        reject(["Unable to logout"]);
                    }
                } else {
                    reject(["Something wen wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const verifyAdminApi = async () => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}verify`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.status === 401) {
                    // Handle 401 Unauthorized error
                    resolve(["Session timeout, please login again."]);
                    reject(["Session timeout, please login again."]);
                }
                else if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(["Session timeout, please login again."]);
                        reject(["Session timeout, please login again."]);

                    }
                }
                else {
                    resolve(["Something went wrong, please try again later"]);
                    reject(["Something went wrong, please try again later"]);

                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Session timeout, please login again."]);
                resolve("Session timeout, please login again.")

            })
        })

    }
};